<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.editAssignedEmployers_header | titlecase }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      (click)="cancel()"
      [attr.aria-label]="data.sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>
<mat-dialog-content>
  <div class="header-container">
    <span>{{ data.sysText.editAssignedEmployers_name }}</span>
    <div class="checkbox-container">
      <span>{{ data.sysText.editAssignedEmployers_assigned }}</span>
      @if (data.showDefaults) {
        <span>{{ data.sysText.editAssignedEmployers_default }}</span>
      }
    </div>
  </div>
  <form [formGroup]="form" class="dialog-content-form">
    <div class="scroll-container">
      @for (employerGroup of employers.controls; track employerGroup;) {
        <div class="employer-group-row">
          <div class="flex-box">
            <div class="name-container">{{ employerGroup.controls.employerName.value }}</div>
            <div class="checkbox-container">
              <mat-checkbox
                [formControl]="employerGroup.controls.isAssigned"
                [aria-label]="data.sysText.editAssignedEmployers_assigned">
              </mat-checkbox>
              @if (data.showDefaults) {
                <mat-checkbox
                  [formControl]="employerGroup.controls.isDefault"
                  [aria-label]="data.sysText.editAssignedEmployers_default">
                </mat-checkbox>
              }
            </div>
          </div>
          @if (employerGroup.controls.isDefault.value
            && employerGroup.controls.defaultExists.value) {
            <mat-hint
              class="warn caption"
              >
              {{ data.sysText.assignedEmployers_defaultMessage }}
            </mat-hint>
          }
        </div>
      }
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

